import { geoData } from 'client/javascript/geo';
import { ALL_ACCESS_COUNTRY_ALLOWLIST } from 'shared/util/constants';

const allAccessPromoGeoLocationCheck = (selector = '.all-access-container') => {
  geoData.then(geo => {
    if (ALL_ACCESS_COUNTRY_ALLOWLIST.includes(geo.countryCode)) {
      const _el = document.querySelectorAll(selector);
      _el.forEach(e => {
        e.classList.remove('hidden');
      });
    }
  });
};

export default allAccessPromoGeoLocationCheck;
